import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { USER_INTRO_SAMPLE } from "../consts";
import { UserSceneProps } from "../types";

/** Korak "Osnovni podaci": profil korisnika s inicijalima i OIB-om, pa tim kojem pristupa. */
const UserInfoScene: React.FC<UserSceneProps> = ({ user }) => {
  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="flex flex-col items-center text-center">
            <span className="flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 text-lg font-bold text-blue-700">
              {user.initials}
            </span>
            <div className="mt-3 text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Korisnik</div>
            <div className="max-w-full text-sm font-bold text-slate-800 truncate">{user.fullName}</div>
          </div>

          <div className="mt-4 space-y-2">
            {[
              { label: "OIB", value: user.oib },
              { label: "Poslovnica", value: user.officeName },
            ].map((row) => (
              <div key={row.label} className="flex items-center justify-between gap-2 rounded-md bg-slate-50 px-3 py-2 text-[0.7rem]">
                <span className="text-slate-500">{row.label}</span>
                <span className="font-semibold text-slate-800 truncate">{row.value}</span>
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Tim</div>
          <div className="mt-3 flex -space-x-2">
            {USER_INTRO_SAMPLE.team.map((initials) => (
              <span
                key={initials}
                className="flex items-center justify-center w-8 h-8 rounded-full border-2 border-white bg-slate-100 text-[0.6rem] font-bold text-slate-500"
              >
                {initials}
              </span>
            ))}
            <span className="flex items-center justify-center w-8 h-8 rounded-full border-2 border-white bg-blue-600 text-[0.6rem] font-bold text-white">
              {user.initials}
            </span>
          </div>
          <div className="mt-2 text-[0.65rem] text-slate-400">Član tima u sustavu</div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Svatko ima svoj račun"
          subtitle="Zna se tko je što napravio"
          iconClassName="bg-blue-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#1D4ED8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M12 11a4 4 0 100-8 4 4 0 000 8z" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(UserInfoScene);
